export default "__VITE_ASSET__kdbZgKy1__"